import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  standalone: true,
  selector: 'formly-input-with-icon',
  template: `
    <div class="flex flex-column">
      <label *ngIf="props.label">{{ props.label }} *</label>
      <span class="p-input-icon-right w-full">
        <i
          class="pi"
          [ngClass]="{
            'pi-eye': !isPasswordVisible,
            'pi-eye-slash': isPasswordVisible
          }"
          (click)="togglePasswordVisibility()"
          aria-label="Toggle password visibility"
          role="button"
          style="margin-top: 0rem;"
        ></i>
        <input
          pInputText
          [type]="isPasswordVisible ? 'text' : 'password'"
          [formControl]="$any(formControl)"
          [placeholder]="props.placeholder"
        />
      </span>
      <div *ngIf="showError">
        <div *ngFor="let error of errorMessages">
          <small class="text-danger">{{ error }}</small>
        </div>
      </div>
    </div>
  `,
  imports: [CommonModule, ReactiveFormsModule, InputTextModule]
})
export class InputFieldTypeWithIcon extends FieldType {
  isPasswordVisible = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  get errorMessages() {
    return Object.keys(this.field.formControl!.errors || {}).map((key) =>
      this.errorMessage(key)
    );
  }

  errorMessage(errorKey: string): string {
    const errorMessages: Record<string, string> = {
      minlength: `Should have at least ${this.field.props!.minLength} characters`,
      passwordComplexity:
        'Must contain at least one uppercase letter, one lowercase letter, one number and one special character'
    };

    return errorMessages[errorKey] || '';
  }
}
